import { mapImageConstants } from '../utils/imageMapper';
import aboutData from '../data/aboutData.json';

export interface Person {
  id: string;
  name: string;
  title: string;
  subtitle: string;
  description: string;
  fullDescription?: string | string[];
  image: string;
}

export interface Founder {
  name: string;
  title: string;
  image: string;
}

export interface TeamMember {
  name: string;
  title: string;
  image: string;
}

export interface AboutData {
  heroSection: {
    title: string;
    description: string;
    sectionTitle: string;
  };
  boardOfAdvisors: {
    title: string;
    subtitle: string;
    people: Person[];
  };
  founders: {
    title: string;
    founders: Founder[];
  };
  team: {
    title: string;
    members: TeamMember[];
  };
}

export function useAboutData() {
  const data = mapImageConstants(aboutData as AboutData);
  const loading = false;
  const error = null;

  return { data, loading, error };
}
